import React from "react";
import AdditionalDetails from "../../../AdditionalDetails/AdditionalDetails";
import { useParams } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";
import ContractorAdditionalDetails from "../../../AdditionalDetails/ContractorAdditionalDetails";

interface AdditionalDetailTabContentProps {
  result: any[];
  entityTypeId: EntityType;
}

const AdditionalDetailTabContent: React.FC<AdditionalDetailTabContentProps> = ({ result, entityTypeId }) => {
  const { id } = useParams<{ id: string }>();

  if (!id) return null; // safety check

  return entityTypeId === EntityType.Contractor ? (
    <ContractorAdditionalDetails entityId={Number(id)} entityTypeId={entityTypeId} />
  ) : (
    <AdditionalDetails entityId={Number(id)} entityTypeId={entityTypeId} />
  );
};

export default AdditionalDetailTabContent;
